export const TOUR_STORAGE_KEY = "inkfree.tour.v1";

export const TOUR_STORAGE_SCHEMA = 1;

export const TOUR_Z_INDEX = 1250;

export const TOUR_MODAL_Z_INDEX = 1400;

export const DEFAULT_TARGET_WAIT_MS = 4000;

export const SLOW_TARGET_WAIT_MS = 8000;

export const REVEAL_WAIT_MS = 800;

export const REVEAL_TRIGGER_WAIT_MS = DEFAULT_TARGET_WAIT_MS;

export const AUTO_START_WATCH_INTERVAL_MS = 750;
export const AUTO_START_WATCH_TIMEOUT_MS = 15 * 60 * 1000;

export const ROUTE_SETTLE_MS = 400;

const TOP_NAV_HEIGHT = 64;
const ANNOUNCEMENT_BANNER_HEIGHT = 30;
const SCROLL_OFFSET_PX = TOP_NAV_HEIGHT + 8 + 16;

export const scrollOffsetFor = (hasBanner: boolean): number =>
  hasBanner ? SCROLL_OFFSET_PX + ANNOUNCEMENT_BANNER_HEIGHT : SCROLL_OFFSET_PX;

export const TOUR_ATTRIBUTE = "data-tour";

/** Marks the tour's own dialogs so auto-start gating can ignore them. */
export const TOUR_MODAL_CLASS = "inkfree-tour-modal";
